import React from "react";
import Card from "./Card";
import style from "./Modal.module.css";
const Modal = (props) => {
  return (
    <div onClick={props.buttonClicked} className={style.backdrop}>
      <div className={style.modal}>
        <header className={style.header}>
          <h2>Our Number</h2>
        </header>
        <div>
          <h4>01724935429</h4>
        </div>
        <footer>
          <div>Kitchen Open From 9am To 8pm</div>
        </footer>
      </div>
    </div>
  );
};

export default Modal;
